<template>
    <div class="flex gap-2.5 sm:gap-3">
        <div class="relative flex-none h-16 w-24 sm:h-20 sm:w-32 bg-gray-light">
            <img class="w-full h-full object-contain" :src="productImage" />
        </div>

        <div class="flex flex-col justify-center">
            <p class="text-sm font-medium font-oceanside">
                {{ productName }}
            </p>

            <div
                v-auto-animate
                class="text-sm"
            >
                <p
                    role="button"
                    @click="toggleDetails"
                    class="flex items-center gap-2"
                >
                    <span class="text-base font-semibold">
                        {{ productPrice }}
                    </span>

                    <!--
                    <img
                        src="../assets/images/icons/arrow-dropdown.svg"
                        width="10"
                        height="5"
                        alt=""
                        :class="{ '-rotate-180': showDetails }"
                        class="transition-transform duration-300 ease-in-out"
                    >
                    -->
                </p>

                <ul
                    v-if="showDetails"
                    class="py-2 pl-2 sm:pl-3 text-xs"
                >
                    <li
                        v-for="(selection, index) in itemSelections"
                        :key="index"
                        :class="{ 'mb-1.5' : index + 1 !== selection.values.length }"
                        class="flex flex-col sm:flex-row sm:gap-2"
                    >
                        <p class="whitespace-nowrap">
                            {{ selection.name }}:
                        </p>

                        <p class="italic">
                            {{ getSelectionText(selection.values) }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    import { formatPrice } from '../helpers/format';

    export default {
        mixins: [allStores],

        props: {
            item: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                showDetails: false,
                // placeholder data
                itemSelections: [
                    {
                        name: 'Character Stamping',
                        values: [
                            'Straight',
                            'Jane',
                            'Pink Ribbon',
                        ],
                    },
                    {
                        name: 'Paintfill',
                        values: [
                            'Black',
                            'BV Black',
                            'Pink Ribbon',
                        ],
                    },
                    {
                        name: 'Toe Engraving',
                        values: [
                            'BV Wings',
                            'White/White',
                        ],
                    },
                    {
                        name: 'Flight Lines & Ferrule',
                        values: [
                            '--',
                            'Custom Black/Silver',
                        ],
                    },
                    {
                        name: 'Shaft Band',
                        values: [
                            'BV Best in Class',
                        ],
                    },
                    {
                        name: 'Shaft',
                        values: [
                            'True Temper Dynamic Gold',
                        ],
                    },
                    {
                        name: 'Grip',
                        values: [
                            'Win DriTac',
                        ],
                    },
                    {
                        name: 'Laser Etching',
                        values: [
                            'JD',
                        ],
                    },
                ],
            };
        },

        computed: {
            /**
             * The name of the product being customized.
             */
            productName() {
                return this.item?.controller.blueprint.name;
            },

            /**
             * Extract product price from WebTop data.
             */
            productPrice() {
                const currentPrice = this.item.controller.statePrice({
                    ignoreOptional: true,
                });

                const locale = this.customizerStore.options.locale ?? 'en-US';
                const currency = this.customizerStore.options.currency ?? 'USD';

                return formatPrice(currentPrice.current, false, locale, currency);
            },

            productImage() {
                return this.item.recipe.custom['v-preview-url'];
            },
        },

        methods: {
            toggleDetails() {
                // this.showDetails = !this.showDetails;
            },

            getSelectionText(values) {
                let text = '';

                values.forEach((value, index) => {
                    text += value;

                    if (index + 1 !== values.length) {
                        text += ', ';
                    }
                });

                return text;
            },
        },
    };
</script>
